import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Pintuanlist from '../entities/product';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';

interface PintuanState extends ListState<Pintuanlist> {
    editSeckilllist: Pintuanlist;
}
class PintuanModule extends ListModule<PintuanState, any, Pintuanlist> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Pintuanlist>(),
        loading: false,
        editTemplate: new Pintuanlist(),
        pintuanVersion: 0,
        pintuanProductInfo: [],
        pintuanActInfo: [],
        limitedVersion: 0,
        limitedProductInfo: [],
        limitedActInfo: [],
    };
    public actions = {
        async getAll(context: ActionContext<PintuanState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/BuyLimit/GetBuyLimitList', { params: payload.data });
            context.state.loading = false;
            const page = reponse.data.result as PageResult<Pintuanlist>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }
    };
    public mutations = {
        setState(state, payload) {
            for (let key in payload) {
                state[key] = payload[key]
            }
        },
        setCurrentPage(state: PintuanState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PintuanState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: PintuanState, Pintuanlist: Pintuanlist) {
            state.editSeckilllist = Pintuanlist;
        },
    };
}
const pintuanModule = new PintuanModule();
export default pintuanModule;
